import { useParams } from "react-router-dom";
import { usePortalPreflight, usePortalBootstrap } from "@/client/lib/portal";
import { PortalNav } from "@/client/components/school-portal/PortalNav";
import { PortalHeader } from "@/client/components/school-portal/PortalHeader";
import { PhoneIcon, MailIcon } from "lucide-react";

// The KUVO contact page. Same shell as the other portal tabs (PortalNav on top, then the
// shared mx-auto max-w-7xl main with PortalHeader), so the heading sits in the identical
// spot. Static content, so no data fetch beyond the bootstrap that gives PortalNav the
// school name (cached, shared with the rest of the portal).
export function ContactPage() {
  const { schoolId: scIdParam } = useParams<{ schoolId: string }>();
  const schoolId = Number(scIdParam);
  usePortalPreflight(schoolId);
  const { data: bootstrap } = usePortalBootstrap(schoolId);

  return (
    <div className="min-h-screen bg-background">
      <PortalNav schoolName={bootstrap?.school.schoolName} schoolId={schoolId} />
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
        <PortalHeader
          title="Contactgegevens KUVO"
          subtitle="Hier vindt u hoe u ons kunt bereiken."
        />

        <div className="max-w-xl space-y-8">
          <p className="text-sm leading-6 text-muted-foreground">
            Mocht er iets onduidelijk zijn, dan stellen wij het zeer op prijs als u dit via de
            mail laat weten. Telefonisch zijn wij ook bereikbaar.
          </p>

          <section>
            <h2 className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Adres</h2>
            <address className="mt-2 text-sm not-italic leading-6 text-foreground">
              Wilhelminaweg 77
              <br />
              3441 XB Woerden
            </address>
          </section>

          <section>
            <h2 className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Telefoon</h2>
            <a href="tel:0643814181" className="mt-2 flex items-center gap-2 text-sm font-medium text-primary hover:underline">
              <PhoneIcon size={14} className="shrink-0 text-muted-foreground" aria-hidden />
              06-43814181
            </a>
          </section>

          <section>
            <h2 className="text-xs font-medium uppercase tracking-wide text-muted-foreground">E-mail</h2>
            <a href="mailto:carole@kuvowoerden.nl" className="mt-2 flex items-center gap-2 text-sm font-medium text-primary hover:underline">
              <MailIcon size={14} className="shrink-0 text-muted-foreground" aria-hidden />
              carole@kuvowoerden.nl
            </a>
          </section>
        </div>
      </main>
    </div>
  );
}
